import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './Section.scss';

export function Section({ children, className }) {
	return (
		<div className={classnames('page-section', className)}>
			{children}
		</div>
	);
}

Section.displayName = 'Section';

Section.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node
	]),
	className: PropTypes.string
};

export default Section;
